import { Entitlements } from './entitlements.model';

export class EntitlementsResult {
    response: Entitlements;
}

